// src/components/PendingApproval.jsx
import PinchIcon from "./PinchIcon";

export default function PendingApproval({ displayName, orgName, onLogout }) {
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <line x1="12" y1="17" x2="12.01" y2="17" />
          </svg>
        </div>
        <div className="auth-title">Pinch Point <PinchIcon /></div>
        <div className="auth-subtitle">Approval Pending</div>
        <div className="auth-form" style={{ textAlign: "center", gap: "1rem" }}>
          <p style={{ margin: 0, color: "var(--text-muted, #888)", fontSize: "0.95rem", lineHeight: 1.6 }}>
            Hi <strong>{displayName}</strong>, your request to join <strong>{orgName || "your organization"}</strong> has been sent.
            An admin must approve your account before you can access the board.
          </p>
          <p style={{ margin: 0, color: "var(--text-muted, #888)", fontSize: "0.85rem" }}>
            Check back here after your admin approves your request.
          </p>
          <button className="submit-btn" onClick={onLogout} style={{ marginTop: "0.5rem" }}>
            Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}
